import React, { useEffect } from "react";
import InnerHero from "../components/InnerHero";
import CompanyOverview from "../components/CompanyOverview";
import OurStory from "../components/OurStory";
import VisionMission from "../components/VisionMission";
import CoreValues from "../components/CoreValues";
import CertificationsCompliance from "../components/CertificationsCompliance";
import ManufacturingProcess from "../components/ManufacturingProcess";
import DistributionNetwork from "../components/DistributionNetwork";
import ResearchInnovation from "../components/ResearchInnovation";
import Testimonials from "../components/Testimonials";
import StatsCounter from "../components/StatsCounter";
import CTASection from "../components/CTASection";
import MapSection from "../components/MapSection";

function About() {
  // scroll animation (one time for home page)
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <InnerHero
        title="About Hindustan Agro Life"
        subtitle="A responsible agricultural solutions company committed to sustainable farming, farmer success, and long-term soil health."
        bgImage="/images/img/about-hero.png"
      />
      <CompanyOverview />
      <OurStory />
      <VisionMission />
      <CoreValues />
      <CertificationsCompliance />
      <ManufacturingProcess />
      <DistributionNetwork />
      <StatsCounter />
      <Testimonials />
      <ResearchInnovation />
      <MapSection />
      <CTASection />

      {/* next about sections yahan aayenge */}
    </>
  );
};

export default About;
